module.exports = __webpack_public_path__ + "media/MRI22-ad.1e95b40e.mp3";